import {
  GET_VALIDATE_ACTION_PLAN_SUCCESS,
  SET_ACTION_PLAN_ID_SUCCESS,
  // SPECIAL FOR ACTION PLAN THREAD
  GET_ACTION_PLAN_THREAD_BY_ACTION_PLAN_ID_SUCCESS,
} from "./constants"

const initialState = {
  actionPlanToValidate: [],
  newActionPlanIdCreated: "",
  actionPlanThread: {},
}

function actionPlanReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_VALIDATE_ACTION_PLAN_SUCCESS:
      return {
        ...state,
        actionPlanToValidate: payload,
      }
    case SET_ACTION_PLAN_ID_SUCCESS:
      return {
        ...state,
        newActionPlanIdCreated: payload,
      }
    // SPECIAL FOR ACTION PLAN THREAD
    case GET_ACTION_PLAN_THREAD_BY_ACTION_PLAN_ID_SUCCESS:
      return {
        ...state,
        actionPlanThread: payload,
      }
    default:
      return state
  }
}

export default actionPlanReducer
